import { FC } from 'react';

import { Texts } from '.';

export interface TextsProps {
  urlText: string;
  url?: string;
}

interface TextWithUrlProps {
  className?: string;
  classNameUrl?: string;
  texts: TextsProps[];
}

export const TextWithUrl: FC<TextWithUrlProps> = ({
  className = '',
  classNameUrl = '',
  texts,
}) => {
  return (
    <Texts className={className}>
      {texts.map((element, index) =>
        element.url ? (
          <a
            key={index}
            className={classNameUrl}
            href={element.url}
            target="_blank"
          >
            {element.urlText}
          </a>
        ) : (
          <span key={index} className={className}>
            {element.urlText}
          </span>
        )
      )}
    </Texts>
  );
};
